import { memo, useReducer } from "react"
import { StateProp } from "../types"
import ModalContext from "./context"
import { initial_modal, modalReducer } from "./reducer"

const ModalState = memo(({ children }: StateProp) => {
  const [modal, dispatch] = useReducer(modalReducer, initial_modal)
  
  return (
    <ModalContext.Provider value={{ modal, dispatch }} >
      {children}
    </ModalContext.Provider>
  )
})

export default ModalState
